import { CodeReply, CodeWrapper, PrepareCodeRunReply } from "@/types/codeTypes";
import { Client } from "./client";

export class CodeController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  public async updateCode(req: CodeWrapper): Promise<CodeReply> {
    return this.client.update(`/api/codes/${req.code.id}`, req);
  }

  /** What veriform-desktop needs to run this operation on the user's machine. */
  public async prepareRun(codeId: string): Promise<PrepareCodeRunReply> {
    return this.client.create(`/api/codes/${codeId}/prepare`, {});
  }
}
